import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import '../styles/main.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { CustomProvider } from 'rsuite';
import useWindowResizeObserver from 'hooks/useWindowResizeObserver';

type AppProviderProps = {
  children: React.ReactNode;
};

const description = ``;

export default function AppProvider({ children }: AppProviderProps) {
  useWindowResizeObserver();
  return (
    <HelmetProvider>
      <Helmet>
        <title>My TXT - URBANTXT Teens Exploring Technology </title>
        <meta name="description" content={description} />
      </Helmet>
      <CustomProvider theme="light">
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          {children}
        </Router>
      </CustomProvider>
    </HelmetProvider>
  );
}
